<template>
  <div>
    <b-card no-body class="card-transparent-background" v-if="type == 'register'">
      <b-card-header class="p-0">
        <b-card-title class="card-title-form-steps-garden-help">
          Customer Registration
        </b-card-title>
        <b-card-sub-title class="card-subtitle-form-steps-garden-help">
          Please provide us with your details to start working now
        </b-card-sub-title>
      </b-card-header>
    </b-card>

    <b-card no-body class="" :class="{ 'card-transparent-background my-0': type == 'add' || type == 'view' }">
      <b-card-header class="card-title-garden-help-default p-2" :class="{ 'mt-2 ': type == 'register' }">
        {{ card_title ? card_title : 'Personal Details' }}
      </b-card-header>

      <b-card-body class="" :class="{
        'p-2': type == 'profile' || type == 'edit',
        'py-0 pr-0 pl-4': type == 'add' || type == 'view',
        'py-0': type == 'register'
      }">
        <div class="">
          <b-row>
            <b-col sm="12" v-if="view_select_customer">
              <b-form-group class="form-group-garden-help" label="Customer" label-for="selected_customer_id"
                :selected_customer_id="selected_customer_id" label-class="form-label-garden-help">
                <p class="error_validation_message_p_gardenhelp" v-if="invalid_customer_id">
                  Please select customer
                </p>
                <v-select :options="customer_list" v-model="_selected_customer_id" name="selected_customer_id"
                  title="selected_customer_id" placeholder="Choose customer" label="name" :reduce="(item) => item.id"
                  :clearable="false" :multiple="false" required>
                </v-select>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group class="form-group-garden-help" :label="type != 'view' ? 'First Name*' : 'First Name'"
                label-for="first_name" :first_name="first_name" label-class="form-label-garden-help">
                <p class="error_validation_message_p_gardenhelp" v-if="invalid_first_name">
                  Please enter first name
                </p>
                <b-form-input v-if="type == 'register' || type == 'add' || type == 'edit'" id="first_name"
                  class="form-control-garden-help" v-model="_first_name" :first_name="first_name"
                  placeholder="Enter first name" required></b-form-input>
                <span v-if="type == 'profile' || type == 'view'" class="form-control form-control-garden-help">
                  {{ _first_name }}
                </span>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group class="form-group-garden-help" :label="type != 'view' ? 'Last Name*' : 'Last Name'"
                label-for="last_name" :last_name="last_name" label-class="form-label-garden-help">
                <p class="error_validation_message_p_gardenhelp" v-if="invalid_last_name">
                  Please enter last name
                </p>
                <b-form-input v-if="type == 'register' || type == 'add' || type == 'edit'" id="last_name"
                  class="form-control-garden-help" v-model="_last_name" :last_name="last_name"
                  placeholder="Enter last name" required></b-form-input>
                <span v-if="type == 'profile' || type == 'view'" class="form-control form-control-garden-help">
                  {{ _last_name }}
                </span>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group class="form-group-garden-help" :label="type != 'view' ? 'Email Address*' : 'Email Address'"
                label-class="form-label-garden-help">
                <p class="error_validation_message_p_gardenhelp" v-if="invalid_email">
                  Please enter email address
                </p>
                <p class="error_validation_message_p_gardenhelp" v-if="invalid_correct_email">
                  The email is invalid
                </p>
                <b-form-input v-if="type == 'register' || type == 'add' || type == 'edit'" id="email"
                  class="form-control-garden-help" v-model="_email" :email="email" placeholder="Enter email"
                  required></b-form-input>
                <span v-if="type == 'profile' || type == 'view'" class="form-control form-control-garden-help">
                  {{ _email }}
                </span>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group class="mobile-number-input-group-garden-help"
                :label="type != 'view' ? 'Phone Number*' : 'Phone Number'" label-for="phone_number"
                :phone_number="phone_number" label-class="form-label-garden-help">
                <p class="error_validation_message_p_gardenhelp" v-if="invalid_phone_number">
                  Please enter phone number
                </p>
                <vue-tel-input v-if="type == 'register' || type == 'add' || type == 'edit'"
                  class="form-control form-control-garden-help" id="phone_number" v-model="_phone_number" required
                  :defaultCountry="'' + country_code" :key="country_code"></vue-tel-input>
                <span v-if="type == 'profile' || type == 'view'" class="form-control form-control-garden-help">
                  {{ _phone_number }}
                </span>
              </b-form-group>
            </b-col>
            <!-- <b-col sm="12" v-if="view_contact_throught != false">
              <InputRadio field="hello" :field_label="'Contact us through'" :field_model.sync="_contact_through"
                name="contact_through" :options="contact_through_options"
                v-if="type == 'register' || type == 'add' || type == 'edit'" />

              <b-form-group class="form-group-garden-help" label="Contact us through" label-for="contact_through"
                :contact_through="contact_through" label-class="form-label-garden-help"
                v-if="type == 'profile' || type == 'view'">

                <span class="form-control form-control-garden-help">
                  {{ _contact_through }}
                </span>
              </b-form-group>
            </b-col> -->
            <b-col sm="12" class="px-0" v-if="type == 'register'">
              <PasswordValidation input_class="form-control-garden-help form-control-auth-garden-help"
                validation_ul_class="password-validation-ul-garden-help" form_group_class="form-group-garden-help"
                form_label_class="form-label-garden-help" :password.sync="_password" :invalid_password="invalid_password"
                :invalid_correct_password="invalid_correct_password"
                error_message_class="error_validation_message_p_gardenhelp" />
            </b-col>
            <b-col sm="12" class="px-0" v-if="type == 'register'">
              <ConfirmPasswordValidation input_class="form-control-garden-help form-control-auth-garden-help"
                validation_ul_class="password-validation-ul-garden-help" form_group_class="form-group-garden-help"
                form_label_class="form-label-garden-help" :confirm_password.sync="_confirm_password"
                :invalid_confirm_password="invalid_confirm_password"
                :invalid_correct_confirm_password="invalid_correct_confirm_password" :password="_password"
                error_message_class="error_validation_message_p_gardenhelp" />
            </b-col>

          </b-row>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import $ from "jquery";
import moment from "moment";
import InputRadio from "@/components/Inputs/InputRadio.vue";
import PasswordValidation from "@/components/Inputs/PasswordValidation.vue";
import ConfirmPasswordValidation from "@/components/Inputs/ConfirmPasswordValidation.vue";


export default {
  name: "CustomerDetails",
  components: { InputRadio, PasswordValidation, ConfirmPasswordValidation },
  props: [
    "card_title",
    "type",
    "first_name",
    "invalid_first_name",
    "last_name",
    "invalid_last_name",
    "email",
    "invalid_email",
    "invalid_correct_email",
    "phone_number",
    "invalid_phone_number",
    "contact_through",
    "view_contact_throught",
    "selected_customer_id",
    "customer_list", "invalid_customer_id",
    "view_select_customer",
    "password",
    "invalid_password",
    "invalid_correct_password",
    "confirm_password",
    "invalid_confirm_password",
    "invalid_correct_confirm_password",
    "country_code"
  ],
  data() {
    return {
      contact_through_options: [
        { label: "Email", value: "email" },
        { label: "SMS", value: "sms" }
      ],
    };
  },
  watch:{
    country_code(newval){
      console.log("change country code", newval)
      this._phone_number = null
    }
  },
  computed: {
    _selected_customer_id: {
      get() {
        return this.selected_customer_id;
      },
      set(value) {
        this.$emit("update:selected_customer_id", value);
      },
    },
    _first_name: {
      get() {
        return this.first_name;
      },
      set(value) {
        this.$emit("update:first_name", value);
      },
    },
    _last_name: {
      get() {
        return this.last_name;
      },
      set(value) {
        this.$emit("update:last_name", value);
      },
    },
    _email: {
      get() {
        return this.email;
      },
      set(value) {
        this.$emit("update:email", value);
      },
    },
    _phone_number: {
      get() {
        return this.phone_number;
      },
      set(value) {
        this.$emit("update:phone_number", value);
      },
    },
    _contact_through: {
      get() {
        return this.contact_through;
      },
      set(value) {
        this.$emit("update:contact_through", value);
      },
    },
    _password: {
      get() {
        return this.password;
      },
      set(value) {
        this.$emit("update:password", value);
      },
    },
    _confirm_password: {
      get() {
        return this.confirm_password;
      },
      set(value) {
        this.$emit("update:confirm_password", value);
      },
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/projects/garden_help/customer/details_components/PersonalData.vue